var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LKPublicationsStorageFileIcon",style:(_vm.style),domProps:{"textContent":_vm._s(_vm.ext)}})}
var staticRenderFns = []

export { render, staticRenderFns }